module.exports = __webpack_public_path__ + "img/bfbz.45fa9fb5.png";